var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dkmvdbrsya",
    d: "M15 4c2.761 0 5 2.239 5 5 0 1.908-1.069 3.566-2.64 4.41 2.402.858 4.198 2.994 4.57 5.59H19.9c-.463-2.282-2.481-4-4.9-4-2.419 0-4.437 1.718-4.9 4H8.07c.372-2.596 2.168-4.732 4.57-5.592C11.07 12.566 10 10.908 10 9c0-2.761 2.239-5 5-5zM5 9c.552 0 1 .448 1 1v2h2c.552 0 1 .448 1 1s-.448 1-1 1H6v2c0 .552-.448 1-1 1s-1-.448-1-1v-2H2c-.552 0-1-.448-1-1s.448-1 1-1h2v-2c0-.552.448-1 1-1zm10-3c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -420.000000) translate(0.000000, 408.000000) translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qiigj2duob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dkmvdbrsya"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.87,
    mask: "url(#qiigj2duob)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvite);
export default __webpack_public_path__ + "static/media/icon-invite.311406283fa39f0afcce84837010b0f2.svg";
export { ForwardRef as ReactComponent };